module.exports = __webpack_public_path__ + "static/webChat-4f6cc0584a67234fb9978c978a1b33d6.jpg";